module.exports = __webpack_public_path__ + "img/product_55.3865a6e.webp";